<template>
  <div class="sl-loader text-center">
    <div class="sl-loader-spinner">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
  </div>
</template>

<script>
// Mirrors the host app's loader so a journey rendered inside up-spa (or an embedded
// iframe) shows the same spinner throughout, rather than switching to a bootstrap one
// mid-flow.
export default {
  name: "Loader",
};
</script>

<style scoped lang="less">
.sl-loader {
  max-width: 50%;
  margin: 40px auto;

  .sl-loader-spinner {
    color: #87d2dc;
    font-size: 50px;
  }
}
</style>
